var ContactFormResponse = function () {

    return {
        showMessage: function () {
            // $('document').on('submit', function () {
            //     setTimeout(
            //         $(".mi-contact-form").html("<span> Thank you for contacting us!. We will answer you as soon as possible.</span>"),
            //         2000);
            // });

            // var mutationObserver = new MutationObserver(function (mutations) {
            //     mutations.forEach(function (mutation) {
            //         console.log(mutation);
            //     });
            // });
            //
            // mutationObserver.observe(document.documentElement, {
            //     attributes: true,
            //     attributeFilter: ['style']
            // });


            // var target = document.querySelectorAll('img[data-sf-role="loading-img"]');
            //
            // for (var i = 0; i < target.length; i++) {
            //
            //     // create an observer instance
            //     var observer = new MutationObserver(function (mutations) {
            //         mutations.forEach(function (mutation) {
            //             var foo = mutation.target.getAttribute("someAttribute")
            //
            //             if (foo == "someValue")
            //                 mutation.target.style.backgroundColor = "red";
            //         });
            //     });
            //
            //     // configuration of the observer
            //     var config = {attributes: true};
            //
            //     // pass in the target node, as well as the observer options
            //     observer.observe(target[i], config);
            // }
            //
            // // let's change an attribute in a second
            // setTimeout(function () {
            //     target[2].setAttribute('someAttribute', 'someValue');
            // }, 1000);

            //
            // $("#mi-contact-form-email").on('submit', function () {
            //
            //     $(".mi-contact-form").promise().done(function () {
            //         $(this).html("<span> Thank you for contacting us!. We will answer you as soon as possible.</span>")
            //     });
            // });
        }
    }
};